export default __webpack_public_path__ + "static/media/heating.992004dc.jpg";